import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3e771004")

_pushScopeId("data-v-3e771004")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "logoff_wrap"
}
const _hoisted_3 = {
  key: 0,
  class: "officia-login-container"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Logoff = _resolveComponent("Logoff")!
  const _component_LogoffHeader = _resolveComponent("LogoffHeader")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_OfficialLogoff = _resolveComponent("OfficialLogoff")!
  const _component_PhoneLogin = _resolveComponent("PhoneLogin")!
  const _component_KantuFooter = _resolveComponent("KantuFooter")!

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.isShowLogoffWrap)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_Logoff, {
            "close-token": _ctx.viewModel.closeToken
          }, null, 8, ["close-token"])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_LogoffHeader, {
            title: `${_ctx.viewModel.title}-注销验证`
          }, null, 8, ["title"]),
          _createVNode(_component_Tabs, {
            tabs: _ctx.viewModel.tabs,
            "tab-idx": _ctx.viewModel.tabIdx,
            onToggleTab: _ctx.toggleTab
          }, null, 8, ["tabs", "tab-idx", "onToggleTab"]),
          (_ctx.viewModel.tabIdx === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode(_component_OfficialLogoff, {
                  class: "officia-login",
                  size: 154,
                  onVerifySuccess: _ctx.verifySuccess
                }, null, 8, ["onVerifySuccess"])
              ]))
            : (_openBlock(), _createBlock(_component_PhoneLogin, {
                key: 1,
                onVerifySuccess: _ctx.verifySuccess
              }, null, 8, ["onVerifySuccess"])),
          _createVNode(_component_KantuFooter, {
            "tab-idx": _ctx.viewModel.tabIdx
          }, null, 8, ["tab-idx"])
        ]))
  ]))
})